import { render, staticRenderFns } from "./jobfairdetail.vue?vue&type=template&id=24063538&scoped=true"
import script from "./jobfairdetail.vue?vue&type=script&lang=js"
export * from "./jobfairdetail.vue?vue&type=script&lang=js"
import style0 from "./jobfairdetail.vue?vue&type=style&index=0&id=24063538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24063538",
  null
  
)

export default component.exports